import { render, staticRenderFns } from "./TabsCommercials.vue?vue&type=template&id=2d509b74&"
import script from "./TabsCommercials.vue?vue&type=script&lang=js&"
export * from "./TabsCommercials.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports